import type { SupabaseClient } from '@supabase/supabase-js';
import { renderHelpTab } from './help.js';
import type { DashboardContext } from './dashboard.js';
import { connectionPillHtml } from '../lib/connection-pill.js';

// Standalone-Anleitung für den Vario-Verkaufskanal-Tab (Slot
// settings.sales-channels.{appId}.tabs → /#/help). Rendert NUR die Anleitung
// im neuen Design: Mock-Header (go-eCommerce- + Gambio-Logo, Titel, „Gambio
// verbunden") und darunter den Anleitungsinhalt (renderHelpTab, geteilt mit
// dem Dashboard-Tab) - bewusst OHNE App-Menü-/Tab-Leiste. Die Navigation
// drumherum stellt der Vario-Verkaufskanal selbst.

interface HelpPageContext {
  contentEl: HTMLElement;
  supabase: SupabaseClient;
  session: { token: string; tenantId: string; marketplaceKind: string };
  supabaseUrl: string;
}

const HEADER_HTML = `
  <header class="apphead">
    <a class="brand" href="https://www.go-ecommerce.de" target="_blank" rel="noopener" title="go eCommerce">
      <img src="/logo-black.png" alt="go eCommerce" />
    </a>
    <img class="gambio-logo" src="/gambio-logo.png?v=2" alt="Gambio" />
    <span class="hdivider"></span>
    <div class="htitle">
      <div class="heyebrow">Gambio · Anleitung</div>
      <h1>Bedienungsanleitung</h1>
    </div>
    <div class="hactions">${connectionPillHtml()}</div>
  </header>
`;

export function renderHelpPage(ctx: HelpPageContext): void {
  ctx.contentEl.hidden = false;

  // Vario gibt diesem Slot via useFullHeight (in main.ts gesendet) die volle Viewport-Höhe.
  // Ancestor-Kette auf 100% legen, damit das Flex-Layout sie füllt und der Anleitungsinhalt
  // INTERN scrollt. `.go-help-fullpage` macht den Container zur 100%-Flex-Spalte (CSS in
  // patterns.css, analog zu .go-orders-fullpage/.go-products-fullpage).
  document.documentElement.style.height = '100%';
  document.body.style.height = '100%';
  const appEl = document.getElementById('app');
  if (appEl) appEl.style.height = '100%';
  ctx.contentEl.style.height = '100%';
  ctx.contentEl.classList.add('go-help-fullpage');

  ctx.contentEl.innerHTML = `${HEADER_HTML}<div class="go-help-scroll" id="help-host"></div>`;
  const host = ctx.contentEl.querySelector<HTMLElement>('#help-host');
  if (!host) return;

  // renderHelpTab ignoriert den Kontext (_ctx, reiner statischer Inhalt) - die Anleitung
  // braucht kein handshake/navigate wie das Dashboard, daher unknown-Cast statt Fake-Feldern.
  renderHelpTab(host, ctx as unknown as DashboardContext);
}
